// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"510c2905","403":"aa444f89"}[chunkId] + ".chunk.js";
};